module.exports = "/OhNein@2x-6af1caebc6655be56264c004852cb267.png";